import { usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { PostIsSupporter, PostIsSupporterResponse } from '../api/dtos';

const getData = (response?: SWRResponse<PostIsSupporterResponse, PostIsSupporterResponse>) => response?.data?.id;

const getError = (response?: SWRResponse<PostIsSupporterResponse, PostIsSupporterResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useSupporter = (name?: string | null, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {

        return name ?
            () => {
                return new PostIsSupporter({name: name});
            } :
            undefined;
    }, [name])

    return usePost(request, { getData, getError}, configuration);
};

export default useSupporter;